module.exports = __webpack_public_path__ + "img/OlympiadPromo.294dfccb.png";